/* eslint-disable no-nested-ternary */

import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useTextGlobal } from 'hooks';
import { Calculator as Counter, ChangeableBackgroundSection } from 'helpers/components';
import { FeaturesContext } from 'helpers/providers/FeaturesProvider';
import { MOBILE, TABLET, DESKTOP, FROM_TABLET } from 'helpers/styles/media';

const Calculator = () => {
  const features = useContext(FeaturesContext);
  const currencyUSD = features.includes('currency_USD');
  const currencyGBP = features.includes('currency_GBP');
  const currencyEuro = features.includes('currency_euro');
  const currencyAusDollar = features.includes('currency_aus_dollar');
  const currencyKrona = features.includes('currency_krona');
  const isCurrencyBeforeAmount = features.includes('is_currency_before_amount'); // for calculator error message
  const isRedVersion = features.includes('red_version');
  const isBnstVersion = features.includes('bnst_version');
  const isBNacPaVersion = features.includes('bnacpa_version');
  const isSwcVersion = features.includes('swc_version');
  const isBnrVersion = features.includes('bnr_version');
  const isPmEVersion = features.includes('pme_version');
  const isGtcVersion = features.includes('gtc_version');
  const isItauVersion = features.includes('itau_version');

  let calcCurrency;
  switch (true) {
    case currencyGBP:
      calcCurrency = '£';
      break;
    case currencyEuro:
      calcCurrency = '€';
      break;
    case currencyAusDollar:
      calcCurrency = 'A$';
      break;
    case currencyKrona:
      calcCurrency = 'KR';
      break;
    case currencyUSD:
      calcCurrency = ' USD';
      break;
    default:
      calcCurrency = '$';
      break;
  }

  return (
    <ChangeableBackgroundSection
      id="calculator-background"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <CalculatorContainer>
          <CalculatorBlock>
            <Title>
              {useText('calc__title', true)}
            </Title>
            <Counter
              currency={calcCurrency}
              isCurrencyBeforeAmount={isCurrencyBeforeAmount}
              investmentText={useText('calc__investment')}
              profitText={useText('calc__profit')}
              buttonText={useText('calc__button')}
              buttonStyles={
                isRedVersion ||
                isBNacPaVersion ||
                isSwcVersion ||
                isBnrVersion ||
                isPmEVersion ||
                isGtcVersion
                  ? whiteButtonStyles
                  : isItauVersion
                    ? buttonStylesV2
                    : buttonStyles
              }
              investmentTitleStyles={investmentTitleStyles}
              profitTitleStyles={
                isRedVersion ||
                isBNacPaVersion ||
                isSwcVersion ||
                isBnrVersion ||
                isPmEVersion ||
                isGtcVersion
                  ? whiteProfitTitleStyles
                  : isItauVersion
                    ? profitTitleStylesV2
                    : profitTitleStyles
              }
              profitBlockStyles={profitBlockStyles}
              investmentBlockStyles={investmentBlockStyles}
              primaryColor="rgb(140, 194, 60)"
              errorMessage={useTextGlobal('calculator_error')}
            />
          </CalculatorBlock>
        </CalculatorContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.div`
  @media ${DESKTOP} {
    padding: 48px 0 49px;
  }

  @media ${TABLET} {
    padding: 59px 0 49px;
  }

  @media ${MOBILE} {
    padding: 44px 0 37px;
  }
`;

const CalculatorContainer = styled(Container)`
  @media ${MOBILE} {
    max-width: inherit;
  }
`;

const CalculatorBlock = styled.div`
  @media ${DESKTOP} {
    width: 75%;
    padding-left: 34px;
  }
`;

const Title = styled.div`
  font-weight: bold;
  color: #064572;

  @media ${DESKTOP} {
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 24px;
  }

  @media ${TABLET} {
    text-align: center;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 24px;
  }

  @media ${MOBILE} {
    text-align: center;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 24px;
  }

  @media ${FROM_TABLET} {

  }
`;

const buttonStyles = css`
  color: #fff;
  text-transform: capitalize;

  @media ${DESKTOP} {

  }

  @media ${TABLET} {

  }

  @media ${FROM_TABLET} {

  }

  @media ${MOBILE} {

  }
`;

const buttonStylesV2 = css`
  background-color: #003399;
  color: #fef851;

  @media ${DESKTOP} {

  }

  @media ${TABLET} {

  }

  @media ${FROM_TABLET} {

  }

  @media ${MOBILE} {

  }
`;

const whiteButtonStyles = css`
  color: #fff;

  @media ${FROM_TABLET} {

  }

  @media ${MOBILE} {

  }
`;

const investmentTitleStyles = css`
  color: #fff;
  text-transform: capitalize;

  @media ${MOBILE} {

  }
`;

const profitTitleStyles = css`
  color: #fff;
  text-transform: capitalize;

  @media ${MOBILE} {

  }
`;

const profitTitleStylesV2 = css`
  color: #fef851;
  @media ${MOBILE} {

  }
`;

const whiteProfitTitleStyles = css`
  color: #fff;
`;

const investmentBlockStyles = css`
  background: #000;

  @media ${MOBILE} {
    padding: 5px 0 10px;
  }
`;

const profitBlockStyles= css`
  background: #000;

  @media ${MOBILE} {
    padding: 0 0 10px;
  }
`;

export default Calculator;
